import get from './get'
import set from './set'
import logout from './logout'

export default {
  ...logout,
  ...get,
  ...set
}
